// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/integration/external_ticketing/v1/external_ticketing.proto" (package "c1.api.external_ticketing.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { JiraConfig } from "../jira/v1/jira";
/**
 * @generated from protobuf message c1.api.external_ticketing.v1.ServiceDeskIntegrationRef
 */
export interface ServiceDeskIntegrationRef {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.external_ticketing.v1.UpdateConfigRequest
 */
export interface UpdateConfigRequest {
    /**
     * @generated from protobuf field: string integration_id = 1;
     */
    integrationId: string;
    /**
     * @generated from protobuf oneof: config
     */
    config: {
        oneofKind: "jiraConfig";
        /**
         * @generated from protobuf field: c1.api.external_ticketing.jira.v1.JiraConfig jira_config = 10;
         */
        jiraConfig: JiraConfig;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.external_ticketing.v1.UpdateConfigResponse
 */
export interface UpdateConfigResponse {
}
/**
 * @generated from protobuf message c1.api.external_ticketing.v1.DeleteServiceDeskRefRequest
 */
export interface DeleteServiceDeskRefRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.external_ticketing.v1.DeleteServiceDeskRefResponse
 */
export interface DeleteServiceDeskRefResponse {
}
/**
 * @generated from protobuf message c1.api.external_ticketing.v1.GetServiceDeskRefRequest
 */
export interface GetServiceDeskRefRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.external_ticketing.v1.GetServiceDeskRefResponse
 */
export interface GetServiceDeskRefResponse {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: c1.api.external_ticketing.v1.ServiceDeskType type = 2;
     */
    type: ServiceDeskType;
    /**
     * @generated from protobuf field: string display_name = 3;
     */
    displayName: string;
    /**
     * @generated from protobuf field: bool is_bound = 4;
     */
    isBound: boolean;
}
/**
 * @generated from protobuf message c1.api.external_ticketing.v1.CreateServiceDeskRefRequest
 */
export interface CreateServiceDeskRefRequest {
    /**
     * @generated from protobuf field: c1.api.external_ticketing.v1.ServiceDeskType type = 1;
     */
    type: ServiceDeskType;
    /**
     * @generated from protobuf field: string display_name = 2;
     */
    displayName: string;
}
/**
 * @generated from protobuf message c1.api.external_ticketing.v1.CreateServiceDeskRefResponse
 */
export interface CreateServiceDeskRefResponse {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.external_ticketing.v1.GetServiceDeskIntegrationRequest
 */
export interface GetServiceDeskIntegrationRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.external_ticketing.v1.GetServiceDeskIntegrationResponse
 */
export interface GetServiceDeskIntegrationResponse {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string base_url = 2;
     */
    baseUrl: string;
    /**
     * @generated from protobuf field: string display_name = 3;
     */
    displayName: string;
    /**
     * @generated from protobuf field: c1.api.external_ticketing.v1.ServiceDeskType type = 4;
     */
    type: ServiceDeskType;
    /**
     * @generated from protobuf oneof: config
     */
    config: {
        oneofKind: "jiraConfig";
        /**
         * @generated from protobuf field: c1.api.external_ticketing.jira.v1.JiraConfig jira_config = 10;
         */
        jiraConfig: JiraConfig;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.external_ticketing.v1.ListServiceDeskIntegrationsRequest
 */
export interface ListServiceDeskIntegrationsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated c1.api.external_ticketing.v1.ServiceDeskIntegrationRef refs = 3;
     */
    refs: ServiceDeskIntegrationRef[];
}
/**
 * @generated from protobuf message c1.api.external_ticketing.v1.ListServiceDeskIntegrationsResponse
 */
export interface ListServiceDeskIntegrationsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.external_ticketing.v1.GetServiceDeskIntegrationResponse list = 1;
     */
    list: GetServiceDeskIntegrationResponse[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.external_ticketing.v1.UpdateIntegrationNameRequest
 */
export interface UpdateIntegrationNameRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string display_name = 2;
     */
    displayName: string;
}
/**
 * @generated from protobuf message c1.api.external_ticketing.v1.UpdateIntegrationNameResponse
 */
export interface UpdateIntegrationNameResponse {
}
/**
 * @generated from protobuf message c1.api.external_ticketing.v1.ServiceDeskIntegration
 */
export interface ServiceDeskIntegration {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string base_url = 2;
     */
    baseUrl: string;
    /**
     * @generated from protobuf field: c1.api.external_ticketing.v1.ServiceDeskType type = 3;
     */
    type: ServiceDeskType;
    /**
     * @generated from protobuf field: string display_name = 4;
     */
    displayName: string;
    /**
     * @generated from protobuf oneof: config
     */
    config: {
        oneofKind: "jiraConfig";
        /**
         * @generated from protobuf field: c1.api.external_ticketing.jira.v1.JiraConfig jira_config = 100;
         */
        jiraConfig: JiraConfig; // ZohoManageEngineSDPConfig zoho_manage_engine_sdp_config = 101;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf enum c1.api.external_ticketing.v1.ServiceDeskType
 */
export enum ServiceDeskType {
    /**
     * @generated from protobuf enum value: UNKNOWN = 0;
     */
    UNKNOWN = 0,
    /**
     * @generated from protobuf enum value: JIRA = 1;
     */
    JIRA = 1
}
// @generated message type with reflection information, may provide speed optimized methods
class ServiceDeskIntegrationRef$Type extends MessageType<ServiceDeskIntegrationRef> {
    constructor() {
        super("c1.api.external_ticketing.v1.ServiceDeskIntegrationRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.v1.ServiceDeskIntegrationRef
 */
export const ServiceDeskIntegrationRef = new ServiceDeskIntegrationRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateConfigRequest$Type extends MessageType<UpdateConfigRequest> {
    constructor() {
        super("c1.api.external_ticketing.v1.UpdateConfigRequest", [
            { no: 1, name: "integration_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "jira_config", kind: "message", oneof: "config", T: () => JiraConfig }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.v1.UpdateConfigRequest
 */
export const UpdateConfigRequest = new UpdateConfigRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateConfigResponse$Type extends MessageType<UpdateConfigResponse> {
    constructor() {
        super("c1.api.external_ticketing.v1.UpdateConfigResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.v1.UpdateConfigResponse
 */
export const UpdateConfigResponse = new UpdateConfigResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteServiceDeskRefRequest$Type extends MessageType<DeleteServiceDeskRefRequest> {
    constructor() {
        super("c1.api.external_ticketing.v1.DeleteServiceDeskRefRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.v1.DeleteServiceDeskRefRequest
 */
export const DeleteServiceDeskRefRequest = new DeleteServiceDeskRefRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteServiceDeskRefResponse$Type extends MessageType<DeleteServiceDeskRefResponse> {
    constructor() {
        super("c1.api.external_ticketing.v1.DeleteServiceDeskRefResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.v1.DeleteServiceDeskRefResponse
 */
export const DeleteServiceDeskRefResponse = new DeleteServiceDeskRefResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetServiceDeskRefRequest$Type extends MessageType<GetServiceDeskRefRequest> {
    constructor() {
        super("c1.api.external_ticketing.v1.GetServiceDeskRefRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.v1.GetServiceDeskRefRequest
 */
export const GetServiceDeskRefRequest = new GetServiceDeskRefRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetServiceDeskRefResponse$Type extends MessageType<GetServiceDeskRefResponse> {
    constructor() {
        super("c1.api.external_ticketing.v1.GetServiceDeskRefResponse", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "type", kind: "enum", T: () => ["c1.api.external_ticketing.v1.ServiceDeskType", ServiceDeskType] },
            { no: 3, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "is_bound", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.v1.GetServiceDeskRefResponse
 */
export const GetServiceDeskRefResponse = new GetServiceDeskRefResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateServiceDeskRefRequest$Type extends MessageType<CreateServiceDeskRefRequest> {
    constructor() {
        super("c1.api.external_ticketing.v1.CreateServiceDeskRefRequest", [
            { no: 1, name: "type", kind: "enum", T: () => ["c1.api.external_ticketing.v1.ServiceDeskType", ServiceDeskType] },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.v1.CreateServiceDeskRefRequest
 */
export const CreateServiceDeskRefRequest = new CreateServiceDeskRefRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateServiceDeskRefResponse$Type extends MessageType<CreateServiceDeskRefResponse> {
    constructor() {
        super("c1.api.external_ticketing.v1.CreateServiceDeskRefResponse", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.v1.CreateServiceDeskRefResponse
 */
export const CreateServiceDeskRefResponse = new CreateServiceDeskRefResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetServiceDeskIntegrationRequest$Type extends MessageType<GetServiceDeskIntegrationRequest> {
    constructor() {
        super("c1.api.external_ticketing.v1.GetServiceDeskIntegrationRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.v1.GetServiceDeskIntegrationRequest
 */
export const GetServiceDeskIntegrationRequest = new GetServiceDeskIntegrationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetServiceDeskIntegrationResponse$Type extends MessageType<GetServiceDeskIntegrationResponse> {
    constructor() {
        super("c1.api.external_ticketing.v1.GetServiceDeskIntegrationResponse", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "base_url", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { uri: true } } } },
            { no: 3, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "type", kind: "enum", T: () => ["c1.api.external_ticketing.v1.ServiceDeskType", ServiceDeskType] },
            { no: 10, name: "jira_config", kind: "message", oneof: "config", T: () => JiraConfig }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.v1.GetServiceDeskIntegrationResponse
 */
export const GetServiceDeskIntegrationResponse = new GetServiceDeskIntegrationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListServiceDeskIntegrationsRequest$Type extends MessageType<ListServiceDeskIntegrationsRequest> {
    constructor() {
        super("c1.api.external_ticketing.v1.ListServiceDeskIntegrationsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ServiceDeskIntegrationRef }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.v1.ListServiceDeskIntegrationsRequest
 */
export const ListServiceDeskIntegrationsRequest = new ListServiceDeskIntegrationsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListServiceDeskIntegrationsResponse$Type extends MessageType<ListServiceDeskIntegrationsResponse> {
    constructor() {
        super("c1.api.external_ticketing.v1.ListServiceDeskIntegrationsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => GetServiceDeskIntegrationResponse },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.v1.ListServiceDeskIntegrationsResponse
 */
export const ListServiceDeskIntegrationsResponse = new ListServiceDeskIntegrationsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateIntegrationNameRequest$Type extends MessageType<UpdateIntegrationNameRequest> {
    constructor() {
        super("c1.api.external_ticketing.v1.UpdateIntegrationNameRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.v1.UpdateIntegrationNameRequest
 */
export const UpdateIntegrationNameRequest = new UpdateIntegrationNameRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateIntegrationNameResponse$Type extends MessageType<UpdateIntegrationNameResponse> {
    constructor() {
        super("c1.api.external_ticketing.v1.UpdateIntegrationNameResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.v1.UpdateIntegrationNameResponse
 */
export const UpdateIntegrationNameResponse = new UpdateIntegrationNameResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ServiceDeskIntegration$Type extends MessageType<ServiceDeskIntegration> {
    constructor() {
        super("c1.api.external_ticketing.v1.ServiceDeskIntegration", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "base_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "type", kind: "enum", T: () => ["c1.api.external_ticketing.v1.ServiceDeskType", ServiceDeskType] },
            { no: 4, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 100, name: "jira_config", kind: "message", oneof: "config", T: () => JiraConfig }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.external_ticketing.v1.ServiceDeskIntegration
 */
export const ServiceDeskIntegration = new ServiceDeskIntegration$Type();
/**
 * @generated ServiceType for protobuf service c1.api.external_ticketing.v1.ExternalTicketService
 */
export const ExternalTicketService = new ServiceType("c1.api.external_ticketing.v1.ExternalTicketService", [
    { name: "GetServiceDeskIntegration", options: { "authz.method": { role: "VIEWER" } }, I: GetServiceDeskIntegrationRequest, O: GetServiceDeskIntegrationResponse },
    { name: "ListServiceDeskIntegrations", options: { "authz.method": { role: "VIEWER" } }, I: ListServiceDeskIntegrationsRequest, O: ListServiceDeskIntegrationsResponse },
    { name: "CreateServiceDeskRef", options: { "authz.method": { role: "EDITOR" } }, I: CreateServiceDeskRefRequest, O: CreateServiceDeskRefResponse },
    { name: "GetServiceDeskRef", options: { "authz.method": { role: "VIEWER" } }, I: GetServiceDeskRefRequest, O: GetServiceDeskRefResponse },
    { name: "DeleteServiceDeskRef", options: { "authz.method": { role: "EDITOR" } }, I: DeleteServiceDeskRefRequest, O: DeleteServiceDeskRefResponse },
    { name: "UpdateIntegrationName", options: { "authz.method": { role: "EDITOR" } }, I: UpdateIntegrationNameRequest, O: UpdateIntegrationNameResponse },
    { name: "UpdateConfig", options: { "authz.method": { role: "EDITOR" } }, I: UpdateConfigRequest, O: UpdateConfigResponse }
]);
